<template>
  <v-text-field
    label="Total greater than"
    outlined
    dense
    hide-details="auto"
    type="number"
    v-model="filterDatas.amount"
    clearable
    @input="onChange(filterDatas.amount)"
  ></v-text-field>
</template>

<script>
import { mapState } from 'vuex';
import { email } from 'vee-validate/dist/rules';
export default {
  name: 'date',
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    amount: null,
  }),
  computed: {
    ...mapState(['filterDatas']),
  },
  methods: {
    onChange(data) {
      this.$store.commit('UPDATE_TOTAL_AMOUNT_FILTER', data);
      this.$emit('input', this.filterDatas.amount);
    },
  },
  created() {
    this.$emit('input', this.filterDatas.amount);
  },
  watch: {
    clear: {
      handler(val) {
        this.amount = null;
      },
      deep: true,
    },
  },
};
</script>
